import { Box, Icon, IconButton, styled, Tooltip } from 'opensolar-ui'
import React from 'react'
import { useTranslate } from 'react-admin'

interface ThumbsButtonsProps {
  isPositive: boolean | null
  onThumbsClick: (isPositive: boolean) => void
  thumbsUpTooltipKey: string
  thumbsDownTooltipKey: string
  size?: 'small' | 'medium' | 'large'
}

const GREEN = '#4caf50'
const RED = '#f44336'
const DEFAULT_ICON_COLOR = 'rgba(0, 0, 0, 0.6)'

const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => !['$thumbType'].includes(prop as string),
})<{ $thumbType?: 'up' | 'down' }>`
  padding: 3px;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }

  &:hover span {
    color: ${(props) => (props.$thumbType === 'down' ? RED : GREEN)} !important;
  }
`

export const ThumbsButtons: React.FC<ThumbsButtonsProps> = ({
  isPositive,
  onThumbsClick,
  thumbsUpTooltipKey,
  thumbsDownTooltipKey,
  size = 'small',
}) => {
  const translate = useTranslate()

  return (
    <Box display="flex" alignItems="center" gridGap={2} marginTop={0.5}>
      <Tooltip title={translate(thumbsUpTooltipKey)} placement="top">
        <StyledIconButton
          size={size}
          onClick={() => onThumbsClick(true)}
          disableRipple
          $thumbType="up"
          disabled={isPositive === true}
        >
          <Icon icon="thumb_up" size={size} color={isPositive === true ? GREEN : DEFAULT_ICON_COLOR} />
        </StyledIconButton>
      </Tooltip>

      <Tooltip title={translate(thumbsDownTooltipKey)} placement="top">
        <StyledIconButton
          size={size}
          onClick={() => onThumbsClick(false)}
          disableRipple
          $thumbType="down"
          disabled={isPositive === false}
        >
          <Icon icon="thumb_down" size={size} color={isPositive === false ? RED : DEFAULT_ICON_COLOR} />
        </StyledIconButton>
      </Tooltip>
    </Box>
  )
}
